@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in">
      <div class="h-full flex items-center">
        <mat-slide-toggle class="mr-4" color="primary" [(ngModel)]="checked" [disabled]="field.readonly || field.control.disabled">
        </mat-slide-toggle>
        <div class="flex-auto">
          <div class="leading-6 font-medium">{{ field.label | localize }}</div>
          @if (field.hint) {
            <div class="text-md text-secondary">{{ field.hint | localize }}</div>
          }
        </div>
      </div>
      @if (!field.readonly &&
        field.control.touched &&
        field.control.errors) {
        @if (field.control.hasError('invalidValue')) {
          <div class="text-sm text-warn leading-none font-medium">
            {{ 'checkIsMandatory' | transloco }}
          </div>
        }
      }
    </div>
  }
} @else {
  {{ (field.control.value ? 'yes' : 'no') | transloco }}
}

